module.exports = __webpack_public_path__ + "static/media/southern-coop-menu-2024.adf88cd9.jpg";